import {useRouteMatch} from "react-router";
import {PATHS} from "../../../route-dictionary";

const useRuleIdParams = () => {
  const ruleDetailsPageRouteObj = useRouteMatch(PATHS.RULES.DETAILS);
  const checkRuleDetailsPageRouteObj = useRouteMatch(PATHS.CHECKS.RULE_DETAILS);
  const isRuleDetailsPage = !!ruleDetailsPageRouteObj || !!checkRuleDetailsPageRouteObj;

  const ruleId = !isRuleDetailsPage ? null :
    (ruleDetailsPageRouteObj?.params.id || checkRuleDetailsPageRouteObj?.params.id);

  return {isRuleDetailsPage, ruleId};
};

export default useRuleIdParams;